import './Avatar.scss';
import React, { memo } from 'react';
import { AssetImage } from 'src/modules/common/components/AssetImage';
import { AuthUser } from 'src/modules/common/types/AuthUser';
import { ProjectOwner } from 'src/modules/common/types/ProjectOwner';
import { BodyMedium01 } from 'src/modules/common/typography/BodyMedium01';
import { HelperText01 } from 'src/modules/common/typography/HelperText01';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';

type Props = {
  readonly user: AuthUser | SharedUser | ProjectOwner;
  readonly showDetails?: boolean;
};

export const Avatar = memo(({ user, showDetails }: Props) => {
  const { avatar, firstName, lastName, jobTitle } = user;

  return (
    <div className="bp-avatar">
      {avatar ? (
        <AssetImage
          asset={avatar}
          size="small"
          className="bp-avatar__content"
        />
      )
        : (
          <div className="bp-avatar__content" style={{ backgroundColor: user.avatarColor }}>
            <div className="bp-avatar__placeholder">
              {firstName[0]}{lastName[0]}
            </div>
          </div>
        )}

      {showDetails && (
        <div className="bp-avatar__details">
          <BodyMedium01>
            {firstName} {lastName}
          </BodyMedium01>

          <HelperText01>
            {jobTitle}
          </HelperText01>
        </div>
      )}
    </div>
  );
});
